import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { connect } from 'react-redux';
import {
  Link,
  Button,
  Status,
  Tooltip,
  Icon,
} from 'components';
import { formatDateString } from 'utils/formatString';

import { isEmpty } from 'ramda';
import { SpeedUpPopup } from '../SpeedUpPopup';
import styles from './styles.pcss';
import { getBalance, getPricePeriod, getTotalRcRate } from '../../../Home/selectors';
import {
  getFTTBTariffAdditionalParams, getFTTBTariffPreset, getFTTBTariff, getFTTBIsActive, getFTTBTurboSpeedUp,
  getFTTBLogin, getFTTBspeedUps, getFTTBIsSpeedUpAvailable, getFTTBTariffPrice, getFTTBLoginAlias,
} from '../../store/selectors';

const cx = classNames.bind(styles);
const SHAPED_SERVICE_TYPES = ['S', 'SHAPED-MULTI-SERVICE', 'SHAPED'];

const SpeedRow = ({ title, children }) => (
  <div className={cx('speedRow')}>
    <div className={cx('speedLabel')}>{title}</div>
    <div className={cx('speedValue')}>
      {children}
    </div>
  </div>
);

const _InternetTariff = ({
  shortDescription,
  price,
  preset,
  alias,
  login,
  speedUps,
  turboSpeedUp,
  balance,
  totalRcRate,
  isSpeedUpAvailable,
  isActive,
  pricePeriod,
  additionalParams,
  forms,
}) => {
  const [isSpeedUpPopupOpened, changeSpeedUpOpened] = useState(false);
  const [isSpeedInOpened, changeSpeedInOpened] = useState(false);

  const toggleSpeedUpPopup = () => { changeSpeedUpOpened(!isSpeedUpPopupOpened); };
  const toggleSpeedIn = () => { changeSpeedInOpened(!isSpeedInOpened); };

  if (!additionalParams?.serviceType) return null;

  const {
    serviceType: serviceTypeRaw, trafficVolumeIn, priceOut,
    speedIn, speedOut, speedIn1: speedInNeght, speedOut1: speedOutNight,
  } = additionalParams;

  const serviceType = serviceTypeRaw.replace(/_/g, '-'); // USSS docs bug
  const connectedSpeedUp = speedUps.find((s) => s.isConnected);
  const speedUpValue = connectedSpeedUp ? connectedSpeedUp.speedUp : 0;
  const speedInValue = Math.round((speedIn + speedUpValue) / 1000);
  const speedOutValue = Math.round((speedOut + speedUpValue) / 1000);
  const speedInNightValue = Math.round((speedInNeght + speedUpValue) / 1000);
  const speedOutNightValue = Math.round((speedOutNight + speedUpValue) / 1000);
  const tariffPrice = connectedSpeedUp?.price ? connectedSpeedUp.price + price : price;
  const tariffPriceText = tariffPrice > 0 ? `${tariffPrice} ₽ ${pricePeriod}` : 'Бесплатно';
  const priceText = price > 0 ? `${price} ₽ ${pricePeriod}` : 'Бесплатно';

  return (
    <div className={cx('component')}>
      <div className={cx('row')}>
        <div className={cx('cell')}>Логин</div>

        <div className={cx('cell')}>
          {login}
          {' '}
          {alias && (<span className={cx('label')}>{alias}</span>)}
        </div>

        <div className={cx('cell')}>
          {isActive ? (
            <Status className={['success', 'compact']}>Договор активен</Status>
          ) : (
            <Status className={['error', 'compact']}>Договор заблокирован</Status>
          )}
        </div>
      </div>

      {forms && (
        <div className={cx('row', 'formsRow')}>{forms}</div>
      )}

      <div className={cx('row')}>
        <div className={cx('cell')}>
          Тариф
          {shortDescription && (<Tooltip>{shortDescription}</Tooltip>)}
        </div>

        <div className={cx('cell')}>
          {connectedSpeedUp ? (
            <div className={cx('speedInWrap')}>
              <Link onClick={toggleSpeedIn}>{`${speedInValue} Мбит/с`}</Link>
              <Icon name="dropdownArrow" className={cx('arrowIcon', { opened: isSpeedInOpened })} />
            </div>
          ) : `${speedInValue} Мбит/с`}
        </div>

        <div className={cx('cell')}>
          {tariffPriceText}
        </div>
      </div>

      {isSpeedInOpened && (
        <div className={cx('row', 'wrap')}>
          <div className={cx('speedInRow')}>
            <div className={cx('cell')}>Скорость по тарифу</div>
            <div className={cx('cell')}>
              {`${speedInValue} Мбит/с`}
            </div>
            <div className={cx('cell')}>{priceText}</div>
          </div>
          <div className={cx('speedInRow')}>
            <div className={cx('cell')}>Опция «Увеличить скорость»</div>
            <div className={cx('cell')}>
              {`${connectedSpeedUp.speedUp / 1000} Мбит/с`}
            </div>
            <div className={cx('cell')}>
              {`${connectedSpeedUp.price} ₽ ${pricePeriod}`}
            </div>
          </div>
        </div>
      )}

      <div className={cx('row')}>
        <div className={cx('cell')}>
          <div className={cx('speedTitle')}>Текущая скорость интернета:</div>

          {serviceType === 'N' && (
            <>
              <SpeedRow title="Входящая днем/ночью">
                {`до ${speedInValue} / ${speedInNightValue} Мбит/с `}
              </SpeedRow>
              <SpeedRow title="Исходящая днем/ночью">
                {`до ${speedOutValue} / ${speedOutNightValue} Мбит/с `}
              </SpeedRow>
            </>
          )}

          {(serviceType === 'U' || serviceType === 'MULTI-SERVICE') && (
            <>
              <SpeedRow title={speedIn === speedOut
                ? 'Входящая/исходящая'
                : 'Входящая'}
              >
                {`до ${speedInValue} Мбит/с`}
              </SpeedRow>

              {speedIn !== speedOut && (
                <SpeedRow title="Исходящая">{`до ${speedOutValue} Мбит/с`}</SpeedRow>
              )}
            </>
          )}

          {serviceType === 'L' && (
            <>
              <SpeedRow title="Входящая">{`до ${speedInValue} Мбит/с`}</SpeedRow>
              <SpeedRow title="Исходящая">{`до ${speedOutValue} Мбит/с`}</SpeedRow>
              <SpeedRow title="Порог по трафику">
                {`${trafficVolumeIn / 1024} ГБ ${pricePeriod}`}
              </SpeedRow>
              <SpeedRow title="Стоимость 1 МБ после порога">{`${priceOut} ₽`}</SpeedRow>
            </>
          )}

          {SHAPED_SERVICE_TYPES.indexOf(serviceType) !== -1 && (
            <>
              <SpeedRow title="Входящая до порога">{`до ${speedInValue} Мбит/с`}</SpeedRow>
              <SpeedRow title="Исходящая до порога">{`до ${speedOutValue} Мбит/с`}</SpeedRow>
              <SpeedRow title="Порог скорости">{`${trafficVolumeIn / 1024} ГБ ${pricePeriod}`}</SpeedRow>
              <SpeedRow title="Входящая после порога">{`до ${speedInNightValue} Мбит/с`}</SpeedRow>
              <SpeedRow title="Исходящая после порога">{`до ${speedOutNightValue} Мбит/с`}</SpeedRow>
            </>
          )}
        </div>
      </div>

      {isSpeedUpAvailable && (
        <div className={cx('row')}>
          <Button onClick={toggleSpeedUpPopup}>
            {connectedSpeedUp
              ? 'Изменить скорость'
              : 'Увеличить скорость'}
          </Button>
        </div>
      )}

      {isSpeedUpPopupOpened && (
        <SpeedUpPopup
          speedUps={speedUps}
          baseSpeed={additionalParams.speedIn}
          basePrice={price}
          presetId={preset.presetId}
          balance={balance}
          totalRcRate={totalRcRate}
          onClose={toggleSpeedUpPopup}
        />
      )}

      {!isEmpty(turboSpeedUp) && (
        <Status className={['attention', cx('speedUp')]} emoji="statusFail">
          Скорость интернета увеличена до
          {' '}
          {turboSpeedUp.speedUp / 1000}
          {' '}
          Мбит/с
          <br />
          Услуга действует до
          {' '}
          {formatDateString(turboSpeedUp.endTime, 'HH:mm DD.MM.YYYY')}
        </Status>
      )}
    </div>
  );
};

_InternetTariff.propTypes = {
  shortDescription: PropTypes.string,
  pricePeriod: PropTypes.string,
  price: PropTypes.number,
  preset: PropTypes.object,
  additionalParams: PropTypes.object,
  login: PropTypes.string,
  speedUps: PropTypes.array,
  balance: PropTypes.number,
  totalRcRate: PropTypes.number,
  isSpeedUpAvailable: PropTypes.bool,

  isActive: PropTypes.bool,
  alias: PropTypes.string,
  turboSpeedUp: PropTypes.object,
  forms: PropTypes.object,
};

const mapStateToProps = (state) => ({
  alias: getFTTBLoginAlias(state),
  login: getFTTBLogin(state),
  price: getFTTBTariffPrice(state),
  isActive: getFTTBIsActive(state),
  balance: getBalance(state),
  speedUps: getFTTBspeedUps(state),
  turboSpeedUp: getFTTBTurboSpeedUp(state),
  pricePeriod: getPricePeriod(state),
  totalRcRate: getTotalRcRate(state),
  isSpeedUpAvailable: getFTTBIsSpeedUpAvailable(state),
  shortDescription: getFTTBTariff(state).shortDescription,
  additionalParams: getFTTBTariffAdditionalParams(state),
  preset: getFTTBTariffPreset(state),
});

export const InternetTariff = connect(mapStateToProps)(_InternetTariff);
